import Vue from "vue";
import Vuetify from "vuetify";
import 'vuetify/dist/vuetify.min.css'
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
// import 'material-design-icons-iconfont/dist/material-design-icons.css' // 确保您正在使用 css-loader
import colors from "vuetify/lib/util/colors";
import { i18n } from "./i18n";

Vue.use(Vuetify);

// // 使用选项创建 VueI18n 实例
// const i18n = new VueI18n({
//   locale: "zhHans", // set locale
//   // messages: messages,
//   messages: {
//     zhHans: require("@/lang/zhHans.js"),
//     en: require("@/lang/en.js"),
//   }, // set locale messages
// });

export default new Vuetify({
  icons: {
    // iconfont: 'md',
    iconfont: "mdi", // 默认值 - 仅用于展示目的
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
    dark: false, //
    themes: {
      // 自定义主题
      light: {
        primary: colors.blue.base,
        secondary: colors.cyan.base,
        accent: colors.teal.base,
        error: colors.red.base,
        warning: colors.orange.base,
        info: colors.lightBlue.base,
        success: colors.green.base,
        red: colors.red.lighten1,
        blue: colors.blue.lighten1,
        orange: colors.orange.lighten1,
        grey: colors.grey.lighten1,
        lightgrey: colors.grey.lighten5,
        green: colors.green.lighten1,
        black: colors.black,
      },
      dark: {
        primary: colors.blue.darken1,
      },
    },
  },
});
